<template>
  <div class="hello">
        <Menu></Menu>
       <div class="class">
            <div class="top wrap clear">
                <h2 class="bold mb-10 float-left">예복습동영상</h2>
            </div>
            <div class="page-top">
                <div class="wrap">
                    <div class="review-top pb-20">
                        <div class="clear">
                            <p class="w-20per">교재</p>
                            <p class="w-80per">New Get Up To Speed Situational 1</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="review-wrap">
                
                <div class="review-wrap">
                    <div class="review-item-title">
                        <p>Lesson 1) Inviting A Friend to Dinner</p>
                    </div>
                    <div class="review-video">
                        <img src="../assets/img/arrow-left-white.png" class="arrow-left"/>
                        <video src="https://cdn.carrotenglish.com:12443/imooc/CSC2007/CSC200723.mp4" type="video/mp4" poster="../assets/img/empty_thumnail.jpg" autoplay loop controls></video>
                        <img src="../assets/img/arrow-right-white.png" class="arrow-right"/>
                    </div>
                </div>
            </div>
            <div class="wrap">
                <div class="mt-10">
                    <button class="btn-base-white">목록</button>
                </div>
            </div>
            
        </div>
        
        <!-- 푸터 -->
        <div class="footer clear">
            Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
        </div>
  </div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
export default {
  name: 'Review',
  components: {
    Menu
  },
  props: {
    msg: String
  },
   data: () => ({
        pwVisible: false,
        tab:1
    }),
    created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");
    },
   mounted() {
    //    this.doc_del_rendar();
   },
   methods: {
      changeTab(target){
          this.tab = target;
      }
   }
//   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');


$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9; 
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.class {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 60px;
    .top {
        padding-right: 20px;
        padding-top: 70px;
        // background: url("../assets/img/top-bg.png") no-repeat right -80px;
        background-size: 300px;
        h2 {
            padding-bottom: 20px;
        }
        position: relative;
        .my-reason{
            position: absolute;
            right: 0;
            bottom: 15%;
        }
    }
    .page-top{
        border-bottom: 1px solid #E9E9E9;
        .review-top{
            
            div{
                background: #F5F5F5 0% 0% no-repeat padding-box;
                border: 1px solid #E9E9E9;
                border-radius: 10px;
                opacity: 1;
                width: 95%;
                margin: 0 auto;
                box-sizing: border-box;
                padding-top: 19px;
                padding-bottom: 19px;
                p{
                    float: left;
                    text-align: center;
                    &:first-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #B7B7B7;
                        opacity: 1;
                    }
                    &:last-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #000000;
                        opacity: 1;
                    }
                }
            }
        }
    }
    .review-wrap{
        width: 100%;
        .review-wrap{
            
        }
        .review-video{
            width: 100%;
            position: relative;
            video{
                width: 100%;
            }
            img{
                position: absolute;
            }
            .arrow-left{
                left: 20px;
                top: 30%;
                cursor: pointer;
            }
            .arrow-right{
                cursor: pointer;
                right: 20px;
                top: 30%;
            }
        }
    }
}
.btn-base-white{
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.footer{
    position: static;
}
@media only screen and (max-width: 414px) {
    .class{
        width: 100%;
    }
}
</style>
